<template>
    <div>
        <template v-if="!products.length">
            <section class="category-header">
                <div class="container-fluid">
                    <div class="category-title mb-3">
                        <h1>{{ description ? description.header : 'Каталог' }}</h1>
                        <span class="pl-2 pt-1">0 моделей</span>
                    </div>
                </div>
            </section>
            <div class="container-fluid">
                <Empty />
            </div>
        </template>
        <template v-else>
            <section class="desktop-category-header">
                <div class="container-fluid">
                    <div class="desktop-category-title">
                        <h1>{{ description ? description.header : 'Каталог' }}</h1>
                        <span class="pl-2 pt-1">{{ totalCount }}</span>
                    </div>
                </div>
            </section>
            <tags></tags>
            <main v-if="initiated" class="desktop-category catalog-section">
                <section v-if="brand" class="desktop-category-brand">
                    <div class="container-fluid">
                        <div class="desktop-category-brand-logo">
                            <img :src="brand.logo" :alt="brand.name">
                        </div>
                        <div class="desktop-category-brand-info">
                            <div class="desktop-category-brand-description" v-html="brand.description"></div>
                            <span class="link link--more">Подробнее</span>
                        </div>
                    </div>
                </section>
                <div class="container-fluid">
                    <div v-if="stock" class="promo">
                        <div class="promo-content">
                            <div v-if="toggleFullDescription" class="promo-description">
                                <h4 class="promo-title">Условия акции</h4>
                                <p class="promo-text" v-html="stock.full_description"></p>
                            </div>
                            <div v-if="!toggleFullDescription" class="promo-description">
                                <h4 class="promo-title">{{ stock.title }}</h4>
                                <p class="promo-text">{{ stock.short_description }}</p>
                            </div>
                            <div class="promo-actions">
                                <div v-if="stock.end_time_timestamp && !promoCodeApplied" class="promo-timer">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px" height="13px">
                                        <path fill="currentColor"
                                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                                    </svg>
                                    <span v-if="countdownDaysLeft">{{ countdownDaysLeft }} {{ countdownDaysLabel }}</span>
                                    <span>{{ countdownHoursLeft }} {{ countdownHoursLabel }}</span>
                                    <span>{{ countdownMinutesLeft }} {{ countdownMinutesLabel }}</span>
                                    <span v-if="!countdownDaysLeft">{{ countdownSecondsLeft }} {{
                                            countdownSecondsLabel
                                        }}</span>
                                </div>
                                <button v-if="stock.applicable"
                                        :disabled="promoCodeApplied"
                                        @click.prevent="applyPromoCode"
                                        title="Кликните чтобы применить"
                                        class="promo-apply">
                                    <template v-if="!promoCodeApplied">
                                        Применить промокод: <span>{{ stock.code }}</span>
                                    </template>
                                    <template v-else>
                                        Промокод <span>{{ stock.code }}</span> применён
                                    </template>
                                </button>
                            </div>
                            <button @click.prevent="toggleViewDescription" title="Условия акции" class="promo-conditional">
                                Условия акции
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid category-container">
                    <section class="desktop-category-list">
                        <div class="desktop-category-list-inner">
                            <template v-if="brand && categories && categories.length !== 0">
                                <ul class="nav-list">
                                    <li v-for="categoriesTree in categories" class="nav-item">
                                        <a class="nav-link"
                                           :href="`${basePath + categoriesTree.slug}/brand_${brand.slug}/`">{{ categoriesTree.name }}</a>
                                    </li>
                                </ul>
                            </template>
                            <filters v-if="filters"></filters>
                            <a v-if="banner && banner.image" :href="banner.url" class="category-list-banner">
                                <img :id="banner.id ? banner.id : false"
                                     class="lazyload"
                                     src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAEALAAAAAABAAEAAAICTAEAOw=="
                                     :data-src="banner.image"
                                     :alt="banner.title"
                                     :title="banner.title"
                                     width="230"
                                     height="157"
                                />
                            </a>
                        </div>
                    </section>
                    <section class="desktop-category-catalog">
                        <div class="catalog-header">
                            <div v-if="selectedFilters && selectedFilters.length" class="selected-filter">
                                <div class="selected-filter-item" v-for="filter in selectedFilters">{{ filter.name }}
                                    <svg @click.prevent="removeSelected(filter.slug, filter.value)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.16446 5.57131L10.9309 0.804835C11.0987 0.637021 11.0987 0.364943 10.9309 0.19715C10.7631 0.0293569 10.491 0.0293355 10.3232 0.19715L5.55675 4.96363L0.790307 0.19715C0.622493 0.0293355 0.350416 0.0293355 0.182623 0.19715C0.0148307 0.364964 0.0148092 0.637042 0.182623 0.804835L4.94907 5.57129L0.182623 10.3378C0.0148092 10.5056 0.0148092 10.7777 0.182623 10.9455C0.266519 11.0294 0.376498 11.0713 0.486476 11.0713C0.596454 11.0713 0.706411 11.0294 0.790328 10.9455L5.55675 6.179L10.3232 10.9455C10.4071 11.0294 10.5171 11.0713 10.627 11.0713C10.737 11.0713 10.847 11.0294 10.9309 10.9455C11.0987 10.7776 11.0987 10.5056 10.9309 10.3378L6.16446 5.57131Z" fill="#7E7E7E"/>
                                    </svg>
                                </div>
                                <div @click.prevent="removeSelected()" class="selected-filter-clear"><svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.7353 0.0712891C10.4789 0.0712891 10.271 0.279156 10.271 0.535583V2.2316C7.88069 -0.0825777 4.06697 -0.0208243 1.75279 2.36947C0.662175 3.49597 0.0537542 5.00332 0.0567739 6.57126C0.0567739 6.82769 0.264641 7.03556 0.521067 7.03556C0.777494 7.03556 0.985334 6.82769 0.985334 6.57126C0.985905 3.75068 3.27288 1.46458 6.09349 1.46515C7.52598 1.46542 8.89247 2.06731 9.85969 3.12395L7.80292 3.80969C7.55933 3.89073 7.42753 4.15387 7.50857 4.39746C7.58961 4.64105 7.85275 4.77285 8.09634 4.69181L10.882 3.76325C11.0722 3.69992 11.2003 3.52168 11.1996 3.32126V0.535555C11.1996 0.279156 10.9917 0.0712891 10.7353 0.0712891Z" fill="#24AAFF"/>
                                    <path d="M11.664 6.10706C11.4076 6.10706 11.1997 6.31492 11.1997 6.57135C11.1992 9.39193 8.91218 11.678 6.09157 11.6775C4.65908 11.6772 3.29259 11.0753 2.32537 10.0187L4.38214 9.33293C4.62573 9.25188 4.75753 8.98874 4.67649 8.74515C4.59545 8.50157 4.3323 8.36976 4.08872 8.4508L1.30301 9.37936C1.11285 9.44269 0.984804 9.62094 0.98543 9.82135V12.6071C0.98543 12.8635 1.1933 13.0713 1.44972 13.0713C1.70615 13.0713 1.91402 12.8635 1.91402 12.6071V10.911C4.30434 13.2252 8.11809 13.1635 10.4322 10.7731C11.5229 9.64664 12.1313 8.13929 12.1283 6.57135C12.1283 6.31492 11.9204 6.10706 11.664 6.10706Z" fill="#24AAFF"/>
                                </svg>Сбросить всё</div>
                            </div>
                            <div v-if="sortOptions && sortOptions.length && selectedSortOption" class="desktop-category-sort dropdown">
                                <button @click.prevent="showSort = !showSort" class="dropdown-toggle">
                                    {{ selectedSortOption.label }}<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" enable-background="new 0 0 64 64"><polygon fill="" points="36.238,44.061 24.271,32.226 36.156,20.115 37.996,21.918 27.907,32.199 38.05,42.229 "></polygon></svg>
                                </button>
                                <div v-if="showSort" class="dropdown-menu">
                                    <a v-for="({ label, icon }, index) in sortOptions" class="dropdown-item"
                                       @click.prevent="sort(index)">
                                        {{ label }}
                                        <q-icon :name="icon" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <bestsellers v-if="bestsellers"></bestsellers>
                        <div class="desktop-category-catalog-inner">
                            <card v-for="(product, index) in products" :lazy-load="parseInt(index) > 3" :key="product.id"
                                  :product="product" :promo-code="stock" :show-article="showArticles"></card>
                        </div>
                        <div v-if="pagination && pagination.total_pages > 1">
                            <pagination v-if="isReady" :current-page="pagination.current_page"
                                        :total-pages="pagination.total_pages" @setPage="setPage"></pagination>
                        </div>
                        <div class="desktop-category-catalog-description" v-if="description && description.description"
                             v-html="description.description"></div>
                    </section>
                </div>
            </main>
            <tags v-if="!hideCategoryBrandTagsSection" type="brands" :header="categoryBrandTagsLabel"></tags>
        </template>
    </div>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
import copy from 'copy-to-clipboard'
import Pagination from "./../Pagination"
import countdown from './../../mixins/countdown'
import Bestsellers from "./../Catalog/Bestsellers"
import Filters from "./../Desktop/Catalog/Filters"
import Tags from "./../Desktop/Carousel/Tag"
import Empty from "../Catalog/Empty.vue";

export default {
    name: 'Catalog',
    components: {
        Empty,
        Pagination,
        Bestsellers,
        Filters,
        Tags,
    },
    mixins: [
        countdown
    ],
    data() {
        return {
            pathName: location.pathname,
            initiated: false,
            stickySidebar: null,
            copied: false,
            banner: null,
            showArticles: false,
            stock: null,
            toggleFullDescription: false,
            brand: {},
            showSort: false,
        }
    },
    mounted() {
        this.banner = window.banner
        this.$store.commit('catalog/setCategoryBrandTagsLabel', window.categoryBrandTagsLabel)
        this.$store.commit('catalog/setHideCategoryBrandTagsSection', window.hideCategoryBrandTagsSection)
        this.$store.commit('catalog/setCategories', window.categories)
        this.$store.commit('catalog/setCategoryId', window.categoryId)
        this.$store.commit('catalog/setPagination', window.pagination)
        this.$store.commit('catalog/setProducts', window.products)
        this.$store.commit('catalog/setFilters', window.filters)
        this.$store.commit('catalog/setPopularLinks', window.popularLinks)
        this.$store.commit('catalog/setSelected', window.selected)
        this.$store.commit('catalog/setBasePath', window.basePath)
        this.$store.commit('catalog/setDescription', window.description)
        this.$store.commit('catalog/setRangeFilters', window.rangeFilters)
        this.$store.commit('catalog/setBreadcrumbs', window.breadcrumbs)
        this.$store.commit('catalog/setSkipFilters', window.skipFilters)
        this.$store.commit('catalog/setExpandCategories', window.expandCategories)
        this.$store.commit('catalog/setBestsellers', window.bestsellers)
        this.$store.commit('catalog/setSortOptions', window.sortOptions)
        this.$store.commit('catalog/setFilterList', window.filterList)
        this.$store.commit('catalog/setSections', window.sections)
        this.$store.commit('catalog/setSimilarProducts', window.similarProducts)
        this.brand = window.brand
        this.stock = window.stock && window.stock.end_time_timestamp ? window.stock : false
        this.showArticles = !!window.showArticles

        this.setBrandOptions(_.get(this.filters, 'brand'))
        this.setColors(window.colors)

        this.$store.commit('catalog/loaded')
        this.initiated = true
        this.setPromoCodeStatus(!!window.promoCodeApplied)

        if (this.stock) {
            this.setCountdownEndTimestamp(this.stock.end_time_timestamp * 1000)
        }
    },
    methods: {
        ...mapMutations('cart', [
            'setPromoCode',
        ]),
        ...mapActions('catalog', [
            'setSorting',
            'setCategoryId',
            'setPage',
            'applyFilters',
        ]),
        ...mapMutations('catalog', [
            'setPromoCodeStatus',
            'setBrandOptions',
            'setColors',
        ]),
        copyToClipboard() {
            copy(this.stock.code)

            this.copied = true
        },
        selectCategory(category) {
            if (parseInt(this.$root.gender) === parseInt(category.gender)) {
                this.setCategoryId(category.id)
            } else {
                let url = this.basePath + category.slug + '/'
                if (this.stock) {
                    url += '?code=' + this.stock.code
                }
                window.location.href = url
            }
        },
        toggleViewDescription() {
            this.toggleFullDescription = !this.toggleFullDescription
        },
        applyPromoCode() {
            let _this = this

            axios.post('/products/apply-promo-code/' + _this.stock.code)
                .then(response => {
                    _this.setPromoCodeStatus(true)
                    _this.setPromoCode(_this.stock.code)
                    _this.$store.dispatch('catalog/update')
                })
                .catch(error => {
                    console.log('failed')
                    console.log(error)
                })
        },
        removeSelected(slug, value) {
            if (slug) {
                if (this.rangeFilters.includes(slug)) {
                    Vue.delete(this.selected, slug)
                } else {
                    for (let slug in this.selected) {
                        for (let i in this.selected[slug]) {
                            if (_.isEqual(value, this.selected[slug][i])) {
                                Vue.delete(this.selected[slug], i)
                            }
                        }
                    }
                }
                if (this.selected[slug] && !this.selected[slug].length) {
                    Vue.delete(this.selected, slug)
                }
            } else {
                for (let slug in this.selected) {
                    if (!['sort', 'dir', 'code'].includes(slug)) {
                        Vue.delete(this.selected, slug)
                    }
                }
            }
        },
        sort(index) {
            this.showSort = ! this.showSort
            this.setSorting(index)
        }
    },
    computed: {
        ...mapState('catalog', [
            'products',
            'pagination',
            'categories',
            'categoryId',
            'description',
            'basePath',
            'expandCategories',
            'bestsellers',
            'filters',
            'promoCodeApplied',
            'sortOptions',
            'selected',
            'rangeFilters',
            'lastUpdate',
            'categoryBrandTagsLabel',
            'hideCategoryBrandTagsSection'
        ]),
        ...mapGetters('catalog', [
            'isReady',
            'selectedSortOption',
            'getFilterBySlug',
            'filterValues'
        ]),
        selectedFilters() {
            let filters = [];
            for (let slug in this.selected) {
                let name = _.get(this.getFilterBySlug(slug), 'name')

                if (this.rangeFilters.includes(slug)) {
                    let value = this.selected[slug];

                    filters.push({
                        slug: slug,
                        name: name + ': '
                            + value.min + ((value.min != value.max) ? (' - ' + value.max) : '')
                            + (value.appendix ? (' ' + value.appendix) : ''),
                        value: value,
                    })
                } else {
                    for (let i in this.selected[slug]) {
                        let value = _.get(_.find(this.filters[slug], (filter) => filter.value === this.selected[slug][i].value), 'name')

                        if (value) {
                            filters.push({
                                slug: slug,
                                name: name + ': ' + value,
                                value: this.selected[slug][i],
                            })
                        }
                    }
                }
            }
            return filters.sort((a, b) => a.name.localeCompare(b.name));
        },
        totalCount () {
            let total = this.pagination.total;

            let digits = total.toString().split('');

            let lastDigit = parseInt(digits.pop());
            let beforeTheLastOneDigit = parseInt(digits.pop());

            if (lastDigit === 1 && ((total < 10) || (beforeTheLastOneDigit !== 1))) {
                return `${total} модель`;
            }

            if ([2, 3, 4].includes(lastDigit) && ((total < 10) || (beforeTheLastOneDigit !== 1))) {
                return `${total} модели`;
            }

            return `${total} моделей`;
        }
    }
}
</script>
